import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--orange);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
  }

  .contact-links{
    ${({ theme }) => theme.mixins.flexCenter};
    margin-top: 50px;
    a {
      ${({ theme }) => theme.mixins.smallButton};
      margin: 0 10px;
    }
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline">What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        My inbox is always open, 
        whether you have a question or just want to say hi, I'll try my best 
        to get back to you!
      </p>
      <div className="contact-links">
        <a className="email-link" href={`mailto:${email}`}>
                Say Hello 
        </a>
        <a className="demo-link" href={`mailto:${email}`}>
                Book Demo 
        </a>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
